// standings/actionCreators.js
import actionTypes from './actionTypes';

//public actions
const changeCurrentSeason = (newSeason) => ({
    type: actionTypes.CHANGE_CURRENT_SEASON,
    payload: {
        season: newSeason
    }
});

const requestStandingsData = () => ({
    type: actionTypes.REQUEST_STANDINGS_DATA
});

const standingsDataResponse = (success, standingsData, date, error) => ({
    type: actionTypes.STANDINGS_DATA_RESPONSE,
    payload: {
        success: success,
        standingsData: standingsData,
        date: date,
        errors: error
    }
});

const tieBreakingProcedureResponse = (success, tieBreakingProcedureData, season, error) => ({
    type: actionTypes.TIE_BREAKING_PROCEDURE_DATA_RESPONSE,
    payload: {
        success,
        tieBreakingProcedureData,
        season,
        error,
    },
});

export default {
    changeCurrentSeason,
    requestStandingsData,
    standingsDataResponse,
    tieBreakingProcedureResponse,
};